import { mapGetters, mapActions } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import Schema from '@/common/components/schemas/json-schema.vue';

export default {
    name: 'mvtFaq',
    components: {
        mvtCollapse,
        Schema,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('msp', ['msp']),
        faqSchema() {
            let schemaObj = null;
            if (this.faqs && this.faqs.length > 0) {
                let schemaTags = this.faqs.map((faq) => {
                    return {
                        '@type': 'Question',
                        name: faq.question,
                        acceptedAnswer: {
                            '@type': 'Answer',
                            text: faq.answer ? faq.answer.replace(/<[^>]+>/g, '') : '',
                        },
                    };
                });
                schemaObj = {
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: schemaTags,
                };
            }
            return schemaObj ? JSON.stringify(schemaObj) : null;
        },
        getDataNoSnippetAttr() {
            return this.attrDataNoSnippet && 'data-nosnippet';
        },
    },
    data() {
        return {
            faqs: [],
            showMore: false,
            isMounted: false,
        };
    },
    props: {
        query: {
            required: false,
        },
        limit: {
            default: 10,
        },
        data: {
            type: Array,
            default: () => [],
        },
        disableCollapse: {
            type: Boolean,
            default: false,
        },
        geo: {
            type: Object,
            required: false,
            default: () => {},
        },
        attrDataNoSnippet: {
            type: Boolean,
            default: false,
        },
        questionTag: {
            type: String,
            default: 'span',
        },
    },
    watch: {
        data: {
            handler(newVaule, oldValue) {
                this.faqs = newVaule;
            },
        },
    },
    methods: {
        ...mapActions('glb', ['fetchFAQs']),
        toggle() {
            this.showMore = !this.showMore;
        },
    },
    mounted() {
        this.isMounted = true;
    },
    created() {
        if (this.data && this.data.length) {
            this.faqs = this.data;
            return;
        }
        this.fetchFAQs({ query: this.query, limit: this.limit }).then((data) => {
            if (data && data.data && data.data.length) {
                if (typeof data.data === 'string') {
                    this.faqs = JSON.parse(data.data);
                } else {
                    this.faqs = data.data;
                }
            }
        });
    },
};
